export const stringToEnumValue = <ET, T>(enumObj: ET, str: string): T | null => {
	const key = Object.entries(enumObj as any).find(
		([, value]) => typeof value === 'string' && value.toLowerCase() === str.toLowerCase()
	)?.[0]
	return key ? (enumObj as any)[key] : null
}
